import React from 'react';
import { connect } from 'react-redux';
import { serviceLocator } from 'infrastructure/ServiceLocator';
import { removeUser, addUser } from 'actions/actions';
import LayoutHelper from './LayoutHelper';
import UserHelper from './UserHelper';

export const WaitForUserMiddleware = (WrappedComponent) => {
  class WaitAuthorization extends React.Component {
    render() {
      if (this.props.user === null || UserHelper.isLoggedIn(this.props.user)) {
        return <WrappedComponent {...this.props} />;
      } else {
        return LayoutHelper.renderLoader();
      }
    }
  }

  const mapStateToProps = (state) => ({
    user: state.user,
  });
  const mapDispatchToProps = (dispatch) => {
    return {};
  };
  return connect(mapStateToProps, mapDispatchToProps)(WaitAuthorization);
};
